var _vars    = require('../../modules/vars')._vars;
var difyApi  = require('../../modules/providers/dify/api');
var aiGating = require('../../modules/ai-gating');
var shared   = require('../../modules/shared');
var templates = require('../../ui/templates/search-results.template');
var loadingMessages = require('../../modules/loading-messages');
var marked   = require('marked');
var parser   = require('../../ui/formatters/key-points-parser');

var lm = null;

var renderer = new marked.Renderer();
renderer.link = function(href, title, text) {
    var isNumeric = /^\d+$/.test((text || '').trim());
    var titleAttr = title ? ' title="' + title + '"' : '';
    var tag = '<a href="' + href + '"' + titleAttr + ' target="_blank" rel="noopener">' + text + '</a>';
    return isNumeric ? '<span class="sr-ai-citation-link">' + tag + '</span>' : tag;
};
renderer.heading = function(text, level) {
    if (level === 3) {
        var clean = text.replace(/<\/?(?:strong|b)>/gi, '');
        return '<h3><b>' + clean + '</b></h3>';
    }
    return '<h' + level + '>' + text + '</h' + level + '>';
};
renderer.strong = function(text) {
    return '<b>' + text + '</b>';
};

function getSearchQuery() {
    return new URLSearchParams(window.location.search).get('q') || '';
}

var isStreamComplete = false;

function isAuthenticated() {
    try {
        return typeof PageMetadata !== 'undefined' &&
               PageMetadata.authVar &&
               Number(PageMetadata.authVar.authLevel) !== 0;
    } catch (e) {
        return false;
    }
}

function buildContinueUrl(query, isComplete) {
    var baseUrl = 'https://www.' + _vars.friendlyEnv + 'medscape.com/ai-search';
    var url;
    if (isComplete && isAuthenticated() && _vars.conversationId) {
        url = baseUrl + '?conversationId=' + encodeURIComponent(_vars.conversationId);
    } else {
        url = baseUrl + '?query=' + encodeURIComponent(query);
    }
    return shared.appendV1Param(url);
}

function setupResultsBox(query) {
    var loadingDiv = document.querySelector('#ai-search-results-box .ai-overview-loading');
    if (!loadingDiv) return null;

    var frag = document.createElement('div');
    frag.innerHTML = templates.aiQueryAnswerContent();

    var ctaBtn = frag.querySelector('.ai-results-cta');
    if (ctaBtn) {
        ctaBtn.addEventListener('click', function() {
            wmdTrack('sr-ai_cont', this);
            window.open(buildContinueUrl(query, isStreamComplete), '_blank', 'noopener');
        });
    }

    var parent = loadingDiv.parentNode;
    while (frag.firstChild) {
        parent.insertBefore(frag.firstChild, loadingDiv);
    }
    parent.removeChild(loadingDiv);

    return document.querySelector('#ai-search-results-box .ai-results-content');
}

function streamAnswer(response, query, onAnswerStart) {
    var reader = response.body.getReader();
    var decoder = new TextDecoder();
    var lineBuffer = '';
    var answerText = '';
    var contentEl = null;

    function processLine(line) {
        if (!line.startsWith('data:')) return;
        try {
            var json = JSON.parse(line.substring(5).trim());
            if (json.thread_id) {
                _vars.conversationId = json.thread_id;
            }
            if (json.type === 'function') {
                var stepTxt = json.step || (json.kwargs && json.kwargs.step);
                if (stepTxt && lm) lm.updateMessage(stepTxt);
            }
            if (json.type === 'ai' && json.content !== undefined) {
                answerText += json.content;
                if (!contentEl) {
                    contentEl = setupResultsBox(query);
                    if (onAnswerStart) onAnswerStart();
                }
                if (contentEl) {
                    contentEl.innerHTML = marked(parser.processStaticHyperlinks(answerText), { renderer: renderer });
                }
            }
        } catch (e) {
            // skip malformed line
        }
    }

    function read() {
        reader.read().then(function(event) {
            if (event.done) {
                if (lineBuffer) processLine(lineBuffer);
                if (!contentEl || !answerText.trim()) {
                    hideResultsBox();
                } else {
                    // The full AI search page loads conversation history by conversationId right
                    // after navigation, but that history isn't reliably indexed until a few
                    // seconds after the stream finishes - so wait before allowing conversationId.
                    setTimeout(function() {
                        isStreamComplete = true;
                    }, 5000);
                    saveToCache(query, contentEl.innerHTML, _vars.conversationId);
                }
                return;
            }
            lineBuffer += decoder.decode(event.value, { stream: true });
            var lines = lineBuffer.split('\n');
            lineBuffer = lines.pop();
            lines.forEach(processLine);
            read();
        }).catch(function() {
            hideResultsBox();
        });
    }

    read();
}

function hideResultsBox() {
    if (lm) { lm.forceStop(); lm = null; }
    var box = document.getElementById('ai-search-results-wrapper');
    if (box) {
        box.remove();
    }
}

function getCacheKey(query) {
    return 'ai-sr-cache:' + query.toLowerCase().trim();
}

var CACHE_TTL_MS = 5 * 60 * 1000; // 5 minutes

function saveToCache(query, html, conversationId) {
    try {
        sessionStorage.setItem(getCacheKey(query), JSON.stringify({
            html: html,
            conversationId: conversationId || '',
            ts: Date.now()
        }));
    } catch (e) { /* ignore quota errors */ }
}

function loadFromCache(query) {
    try {
        var raw = sessionStorage.getItem(getCacheKey(query));
        if (!raw) return null;
        var entry = JSON.parse(raw);
        if (!entry.ts || (Date.now() - entry.ts) > CACHE_TTL_MS) {
            sessionStorage.removeItem(getCacheKey(query));
            return null;
        }
        return entry;
    } catch (e) {
        return null;
    }
}

function initSearchResults() {
    if (initSearchResults._called) return;
    initSearchResults._called = true;

    try {
        if (!_vars.isSearchResultsPage) return;

        if (aiGating.shouldGateAIQuery()) {
            hideResultsBox();
            return;
        };

        var query = getSearchQuery();
        var container = document.querySelector("#ai-search-results-wrapper");
        if (!container) return;

        var viewedTracked = false;
        var isHalfVisible = false;
        var answerStarted = false;

        function checkAndTrackViewed() {
            if (isHalfVisible && answerStarted && !viewedTracked) {
                viewedTracked = true;
                wmdPageLink('sr-ai_ovrvw-viewed');
                viewedObserver.disconnect();
            }
        }

        var viewedObserver = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                isHalfVisible = entry.isIntersecting;
                checkAndTrackViewed();
            });
        }, { threshold: 0.5 });
        viewedObserver.observe(container);

        if (!aiGating.shouldGateAIQuery()) {
            wmdPageLink('sr-ai_ovrvw-imp');
        }
        
        lm = loadingMessages.create({ initialMessage: 'Understanding the query', maxDuration: 15000 });
        lm.start(document.querySelector('.ai-overview-loading-text'));

        var cached = loadFromCache(query);
        if (cached && cached.html) {
            var contentEl = setupResultsBox(query);
            if (contentEl) {
                contentEl.innerHTML = cached.html;
                if (cached.conversationId) {
                    _vars.conversationId = cached.conversationId;
                }
                if (lm) lm.stop();

                isStreamComplete = true;

                answerStarted = true;
                checkAndTrackViewed();
                return; // only skip stream if cache was successfully injected into DOM
            }
            // #ai-search-results-box not found — fall through to stream
        }

        aiGating.markAIQueryUsed();

        difyApi.initializeStream(query)
            .then(function(response) {
                if (!response.ok) {
                    hideResultsBox();
                    return;
                }
                streamAnswer(response, query, function() {
                    if (lm) lm.stop();
                    answerStarted = true;
                    checkAndTrackViewed();
                });
            })
            .catch(function() {
                hideResultsBox();
            });
    } catch (e) {
        hideResultsBox();
    }
}

module.exports = { initSearchResults: initSearchResults };
